// extracted by mini-css-extract-plugin
module.exports = {"snapshot-generator":"VideoThumbnail_snapshot-generator__5OEGx"};